import { Helmet } from 'react-helmet-async';

export default function SEOHead({
  title = '',
  description = '',
  canonical = '',
  ogImage = '/og-home.jpg',
  ogType = 'website',
  keywords = '',
  children = null,
}) {
  const baseTitle = 'AyeSalon';
  // Titles that already name the brand (e.g. CMS blog meta_title "… | Ayesalon")
  // don't get a second " | AyeSalon" appended.
  const fullTitle = !title
    ? `${baseTitle} — Salon Management Software India`
    : /ayesalon/i.test(title)
      ? title
      : `${title} | ${baseTitle}`;

  const baseURL = 'https://ayesalon.com';
  const normalizeCanonical = (value) => {
    if (!value) {
      return `${baseURL}/`;
    }

    const url = value.startsWith('http') ? new URL(value) : new URL(value, baseURL);
    if (url.pathname !== '/' && !url.pathname.endsWith('/')) {
      url.pathname = `${url.pathname}/`;
    }
    url.search = '';
    url.hash = '';

    return url.toString();
  };

  const canonicalURL = normalizeCanonical(canonical);
  const ogImageURL = ogImage.startsWith('http') ? ogImage : `${baseURL}${ogImage}`;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={canonicalURL} />
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="author" content="AyeSalon" />
      <meta httpEquiv="content-language" content="en-IN" />

      {/* Open Graph Tags */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalURL} />
      <meta property="og:image" content={ogImageURL} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="AyeSalon" />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@ayesalon" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImageURL} />

      {/* Additional children schemas if passed */}
      {children}
    </Helmet>
  );
}
